module.exports = __webpack_public_path__ + "img/later_birds.9be5a306.svg";